<template>

<com-item name="games.search" :size="size" :is-blank="true" :no-border="true" :no-hover="true" :any-height="true" class="search">

	<template v-slot:stats>

		<div class="games-search" :class="{'is-focused': is.focused}">

			<div class="games-search-heading">Find game</div>
			<div class="games-search-subheading">Deep dive into any specific game in {{ your }} universe that you have ever owned, rated, played, or wishlisted.</div>

			<div class="games-search-input-wrapper" :class="{'has-results': showResults && results.length}">

				<i class="fa games-search-icon" :class="is.loading ? 'fa-spinner fa-spin' : 'fa-search'"></i>

				<input
					ref="input"
					type="text"
					class="games-search-input"
					placeholder="Search for a game..."
					v-model="query"
					v-on:input="onInput"
					v-on:keydown.down.prevent="onDown"
					v-on:keydown.up.prevent="onUp"
					v-on:keydown.enter.prevent="onEnter"
					v-on:blur="onBlur"
					v-on:focus="onFocus"
				/>

				<div class="games-search-shortcut" v-if="!is.focused && !query"><kbd>/</kbd></div>

				<transition name="results">

					<div class="games-search-results" v-if="showResults && results.length">

						<div
							class="games-search-result"
							v-for="(game, index) in results"
							:key="game.id"
							:class="{ 'is-active': index === activeIndex }"
							v-on:mousedown.prevent="onSelect(game)"
						>

							<img class="games-search-result-image" :src="game.thumbnail" v-if="game.thumbnail" />
							<div class="games-search-result-image games-search-result-image-empty" v-if="!game.thumbnail"><i class="fa fa-dice"></i></div>

							<div class="games-search-result-info">
								<div class="games-search-result-name">{{ game.name }} <span class="games-search-result-year" v-if="game.year">({{ game.year }})</span></div>
								<div class="games-search-result-tags" v-if="game.types && game.types.length">
									<span class="games-search-result-tag" v-for="type in game.types" :key="type" :data-theme="type">{{ type }}</span>
								</div>
							</div>

							<i class="fa fa-arrow-right games-search-result-arrow"></i>

						</div>

					</div>

				</transition>

			</div>

		</div>

	</template>

</com-item>

</template>

<script>

import API from 'core/api'
import comItem from './../common/Item'

export default {

	props: ['fetching', 'your', 'you', 'size'],

	components: {
		'com-item': comItem
	},

	data: function() {

		return {
			query: '',
			results: [],
			activeIndex: -1,
			showResults: false,
			debounce: null,
			requestId: 0,
			is: {
				focused: false,
				loading: false
			}
		}

	},

	mounted: function() {

		document.addEventListener('keydown', this.onGlobalKey)

	},

	beforeDestroy: function() {

		document.removeEventListener('keydown', this.onGlobalKey)

	},

	methods: {

		onGlobalKey: function(e) {

			if (e.key === '/' && !this.is.focused && document.activeElement.tagName !== 'INPUT' && document.activeElement.tagName !== 'TEXTAREA') {

				e.preventDefault()
				this.$refs.input.focus()

			}

		},

		onInput: function() {

			clearTimeout(this.debounce)

			if (this.query.length < 2) {

				this.results = []
				this.is.loading = false
				this.requestId++
				return

			}

			this.debounce = setTimeout(function() {

				this.search()

			}.bind(this), 300)

		},

		search: function() {

			var id = ++this.requestId

			this.is.loading = true

			API.request('games/suggest', { text: this.query, limit: 10, source: 'universe', name: this.$route.params.name, silent: true }).then(function(json) {

				if (id !== this.requestId) return

				this.results = Object.values(json.suggestions || {})
				this.activeIndex = -1
				this.showResults = true
				this.is.loading = false

			}.bind(this), function() {

				if (id !== this.requestId) return

				this.is.loading = false

			}.bind(this))

		},

		onDown: function() {

			if (this.activeIndex < this.results.length - 1) this.activeIndex++

		},

		onUp: function() {

			if (this.activeIndex > 0) this.activeIndex--

		},

		onEnter: function() {

			if (this.activeIndex >= 0 && this.results[this.activeIndex]) {

				this.onSelect(this.results[this.activeIndex])

			}

		},

		onSelect: function(game) {

			this.query = ''
			this.results = []
			this.showResults = false

			this.$router.push({ name: 'InsightsGame', params: { game: game.id } })

		},

		onBlur: function() {

			this.is.focused = false

			setTimeout(function() {

				this.showResults = false

			}.bind(this), 200)

		},

		onFocus: function() {

			this.is.focused = true
			if (this.results.length) this.showResults = true

		}

	}

}

</script>

<style scoped>

.search {
	min-height: 1px;
}

.search >>> .insights-item-content {
	overflow: visible;
}

.games-search {
	position: relative;
	padding: 20px;
	border-radius: 4px;
	background-color: #4881bb;
}

.games-search-heading {
	font-size: 24px;
	font-weight: 600;
	color: #fff;
	margin-bottom: 8px;
}

.games-search-subheading {
	font-size: 14px;
	color: #fff;
	margin-bottom: 16px;
}

.games-search-input-wrapper {
	position: relative;
}

.games-search-icon {
	position: absolute;
	left: 18px;
	top: -2px;
	height: 60px;
	line-height: 60px;
	color: #4881bb;
	font-size: 20px;
	width: 20px;
	text-align: center;
	z-index: 2;
}

.games-search-input {
	width: 100%;
	padding: 18px 60px 18px 54px;
	border-radius: 4px;
	background-color: #fff;
	font-size: 17px;
	font-weight: 400;
	color: #333;
	outline: none;
	border: none;
	transition: border-radius 0.15s ease;
}

.has-results .games-search-input {
	border-radius: 4px 4px 0 0;
}

.games-search-input::placeholder {
	color: #666;
}

.games-search-shortcut {
	position: absolute;
	right: 16px;
	top: 50%;
	transform: translateY(-50%);
	pointer-events: none;
}

.games-search-shortcut kbd {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 26px;
	height: 26px;
	border-radius: 6px;
	border: 1px solid rgba(var(--theme-color), 0.15);
	background: rgba(var(--theme-color), 0.04);
	color: rgba(var(--theme-color), 0.3);
	font-size: 13px;
	font-family: inherit;
	font-weight: 500;
}

.games-search-results {
	position: absolute;
	top: 100%;
	left: 0;
	right: 0;
	background: #fff;
	border-top: 1px solid #e8e8e8;
	border-radius: 0 0 4px 4px;
	max-height: 400px;
	overflow-y: auto;
	z-index: 100;
	box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.results-enter-active {
	transition: opacity 0.15s ease, transform 0.15s ease;
}

.results-leave-active {
	transition: opacity 0.1s ease, transform 0.1s ease;
}

.results-enter,
.results-leave-to {
	opacity: 0;
	transform: translateY(-4px);
}

.games-search-result {
	display: flex;
	align-items: center;
	gap: 12px;
	padding: 10px 16px;
	cursor: pointer;
	transition: background 0.1s;
}

.games-search-result:last-child {
	border-radius: 0 0 4px 4px;
}

.games-search-result:hover,
.games-search-result.is-active {
	background: rgba(72, 129, 187, 0.08);
}

.games-search-result-image {
	width: 44px;
	height: 44px;
	border-radius: 8px;
	object-fit: cover;
	flex-shrink: 0;
}

.games-search-result-image-empty {
	display: flex;
	align-items: center;
	justify-content: center;
	background: rgba(var(--theme-color), 0.05);
	color: rgba(var(--theme-color), 0.15);
	font-size: 18px;
}

.games-search-result-info {
	flex-grow: 1;
	min-width: 0;
}

.games-search-result-name {
	font-size: 14px;
	font-weight: 500;
	color: rgba(var(--theme-color), 0.9);
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.games-search-result-year {
	font-weight: 400;
	color: rgba(var(--theme-color), 0.25);
}

.games-search-result-tags {
	display: flex;
	align-items: center;
	gap: 5px;
	margin-top: 3px;
}

.games-search-result-tag {
	font-size: 12px;
	font-weight: 600;
	line-height: 20px;
	color: #fff;
	padding: 0 7px;
	border-radius: 3px;
	text-transform: capitalize;
}

.games-search-result-tag[data-theme="owned"] {
	background-color: #4881bb;
}

.games-search-result-tag[data-theme="played"] {
	background-color: #2FC482;
}

.games-search-result-tag[data-theme="rated"] {
	background-color: #f5a623;
}

.games-search-result-tag[data-theme="wishlisted"] {
	background-color: #e85d75;
}

.games-search-result-arrow {
	flex-shrink: 0;
	font-size: 12px;
	color: rgba(var(--theme-color), 0.15);
	transition: color 0.1s, transform 0.1s;
}

.games-search-result:hover .games-search-result-arrow,
.games-search-result.is-active .games-search-result-arrow {
	color: #4881bb;
	transform: translateX(2px);
}

.is-mobile .games-search {
	padding: 20px 16px 16px 16px;
}

.is-mobile .games-search-heading {
	font-size: 18px;
}

.is-mobile .games-search-input {
	padding: 14px 16px 14px 38px;
	font-size: 15px;
}

.is-mobile .games-search-icon {
	left: 12px;
	top: 0px;
	height: 47px;
	line-height: 47px;
	font-size: 15px;
	width: 16px;
}

.is-mobile .games-search-shortcut {
	display: none;
}

</style>
